export default __webpack_public_path__ + "static/media/solarstreetlights.1c7b14f1.jpg";